// The three states the backend recognises (SCHEDULE_STATES in pinpointsite/api/models.py). These
// exact strings go on the wire as `schedule_state`.
//
// "all" is a frontend-only sentinel. The server has no "all" value and returns 400 for one, so a
// request on the All tab omits the param entirely.
export const SCHEDULE_STATE_ALL = "all";

// Tab order left to right, top row then bottom (Figma 1832:5341).
export const SCHEDULE_STATE_TABS = [
  { label: "All", value: "all" },
  { label: "Scheduled", value: "scheduled" },
  { label: "Partial", value: "partial" },
  { label: "Unscheduled", value: "unscheduled" },
];

// Derived from the tab table so the two can never drift apart.
export const SCHEDULE_STATE_VALUES = SCHEDULE_STATE_TABS.map((tab) => tab.value);

// Views saved before this shipped stored the old two-state filter. "true" meant "has any entry",
// which is now Scheduled plus Partial; Scheduled is the closest single tab. qs.parse yields
// strings, so the keys are strings.
export const LEGACY_IS_SCHEDULED_TO_STATE = {
  true: "scheduled",
  false: "unscheduled",
};

// The shape of schedule_state_counts, all four at zero. Used when fetchOrders returns without
// asking the server, so the badges cannot describe a set the empty rail contradicts.
export const EMPTY_SCHEDULE_STATE_COUNTS = {
  all: 0,
  scheduled: 0,
  partial: 0,
  unscheduled: 0,
};
